import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';

import { Router } from '@angular/router';
// import { UpdateService } from './services/update.service';

import { Button } from 'primeng/button';
import { ProgressBar } from 'primeng/progressbar';
import { EventLevel } from '../../../event-level.enum';
import { EventLog } from '../../../event-log';
import { EventStatus } from '../../../event-status.enum';
import { SummitNotificationService } from '../../s-notification.service';

@Component({
  selector: 'summit-notification',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
  standalone: true,
  imports: [ProgressBar, Button]
})
export class NotificationItemComponent {
  protected notificationService: SummitNotificationService;
  // protected updateServices: UpdateService;

  constructor(
    public router: Router // private updateServices: UpdateService
  ) {
    this.notificationService = inject(SummitNotificationService);
    // this.updateServices = inject(UpdateService);
  }
  @Input() toastData?: EventLog;
  // data?: EventLog;

  getEventLevelIcon() {
    switch (this.toastData?.eventLevel) {
      case EventLevel.Informational:
        return 'info';
      case EventLevel.Warning:
        return 'warning';
      case EventLevel.Alert:
        return 'error';
      case EventLevel.System:
        return 'build';
      case EventLevel.Unknown:
      default:
        return 'help';
    }
  }

  getEventStatusIcon() {
    switch (this.toastData?.status) {
      case EventStatus.InProgress:
        return 'autorenew';
      case EventStatus.Waiting:
        return 'query_builder';
      case EventStatus.Failed:
        return 'error';
      case EventStatus.Complete:
        return 'check_circle';
      case EventStatus.Unknown:
        return '';
      default:
        return 'help';
    }
  }

  isInProgress() {
    // if (this.data) return this.data.status === EventStatus.InProgress;
    return this.toastData?.status === EventStatus.InProgress;
    // return this.data?.status === EventStatus.InProgress;
  }
  navAndClear(urlLink: string) {
    console.log(`Navigating to ${urlLink} and clearing`);
    this.router.navigateByUrl(urlLink);
    this.notificationService?.clear();
  }
}
